import { T_MongoDoc, T_MongoId } from "../types/_utils.types";

export enum TransactionType {
  CREDIT = "credit",
  DEBIT = "debit",
  VOID = "void",
}

export enum BankStatusType {
  ACTIVE = "active",
  INACTIVE = "inactive",
  CLOSED = "closed",
  SUSPENDED = "suspended",
  UNKNOWN = "unknown",
}

export type BankDto = {
  user: T_MongoId;
  name?: string;
  account_number?: string;
  current_balance?: number;
  transactions: {
    value_date: Date;
    type: TransactionType;
    value: number;
    remarks?: string;
  }[];
  status: BankStatusType;
  attachments: T_MongoId[];
};

export type BankSchemaDto = BankDto & T_MongoDoc;
export type CreateBankDto = BankSchemaDto;
export type UpdateBankDto = Partial<BankSchemaDto>;
